// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const ArrowLeftShaft = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M12.125,18.125 L21.3125,8.9375 C22.0373737,8.21262627 22.0373737,7.03737373 21.3125,6.3125 L21.3125,6.3125 C20.5876263,5.58762627 19.4123737,5.58762627 18.6875,6.3125 L6.41421356,18.5857864 C5.63316498,19.366835 5.63316498,20.633165 6.41421356,21.4142136 L18.6875,33.6875 C19.4123737,34.4123737 20.5876263,34.4123737 21.3125,33.6875 L21.3125,33.6875 C22.0373737,32.9626263 22.0373737,31.7873737 21.3125,31.0625 L12.125,21.875 L33.125,21.875 C34.1605339,21.875 35,21.0355339 35,20 L35,20 C35,18.9644661 34.1605339,18.125 33.125,18.125 L12.125,18.125 Z" />
        </G>
    );
};

export default ArrowLeftShaft;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/arrow-left-shaft/index.js